/* Baci Service 7 — S7: MONTIMI (24 shtator 2026). Ngarkohet PAS baci-service-6.js, PARA baci-car.js.
   Regjistrohet te window.BaciServiceRules: fn(t, lang, raw) → html | null (JO "only": kur mesazhi pyet edhe
   transportin ose orarin, S7 shtohet pas tyre; kur mesazhi ka veture, baci.js pergjigjet se pari per pjesen
   dhe S7 vjen pas — "parakolp per g20 2021 a e montoni" nuk e humb kurre pjesen).

   29 shtator 2026 (pronari): "po montojme cdo gje" — Baci e thote PO kur pyetet, po nuk e permend si perparesi
   (R9) dhe NUK thote asnje shifer (as 50 €, as 150 €) dhe asnje afat: cmimin dhe kohen e montimit e konfirmon
   ekipi → WhatsApp me tekst gati ose Cakto Termin (FAKTI P, /pages/termini).
   Shtesa e vetme faktike (FAKTI F): kontrollo pershtatjen PARA montimit — nderrimi falas per mosperputhje
   vlen 48 ore nga marrja, ne te njejten fjali.

   Kufijte: "a e nderroni nese e kam montu" = S3 (nderrimi; S3 eshte "only" dhe regjistrohet me pare, prandaj
   fiton). "kontrollo para montimit" nuk e shkruan klienti. Fjalet krahasohen si fjale te plota (U.has). */
(function () {
  var U = window.BaciServiceUtil;
  if (!U || !window.BaciServiceRules) return;
  var any = U.any, waLink = U.waLink, termLink = U.termLink;

  var INSTALL = ['montoni', 'monton', 'montojne', 'montoj', 'montojme', 'montohet', 'montim', 'montimi', 'montimin', 'montimit',
    'montu', 'montue', 'montuar', 'montim falas', 'me montu', 'me e montu', 'ma montoni', 'ma montoni ju', 'ta montoj',
    'instalim', 'instalimi', 'instalimin', 'instaloni', 'instalon', 'instalu', 'instaluar', 'me instalu',
    'vendosni', 'vendosje', 'vendosjen', 'ma vendosni', 'me vendos', 'me e vendos', 'ma vini', 'ma qitni', 'me qit',
    'servis me montim', 'punetori', 'punetorine', 'punetorise', 'mekanik', 'mekaniku', 'majstor', 'majstori', 'mjeshter', 'mjeshtri',
    'install', 'installed', 'installing', 'installation', 'installs', 'fit it', 'fitting', 'fitted', 'mount', 'mounting', 'mounted',
    'put it on', 'labour', 'labor', 'workshop', 'mechanic',
    'einbau', 'einbauen', 'eingebaut', 'einbauservice', 'montage', 'montieren', 'montiert', 'anbau', 'anbauen', 'anbringen',
    'baut ihr', 'einbaut', 'werkstatt', 'mechaniker'];

  var T = {
    sq: {
      body: 'Po — <b>montimin e bëjmë ne</b>, te dyqani në Ferizaj (e hënë–e shtunë 08:00–19:00), për çdo pjesë që e shesim. Çmimin dhe kohën e montimit për pjesën tënde ta konfirmon ekipi — shkruaj në WhatsApp me pjesën dhe veturën, ose cakto një termin. Nëse e monton diku tjetër, kontrolloje përshtatjen para montimit — ndërrimi falas për mospërshtatje vlen 48 orë nga marrja.',
      wa: 'Përshëndetje, sa kushton montimi dhe kur mund të vij? Pjesa: ____, vetura: ____.',
      waLabel: 'Pyet ekipin në WhatsApp', term: 'Cakto termin'
    },
    en: {
      body: 'Yes — <b>we do the installation ourselves</b>, at the shop in Ferizaj (Monday–Saturday 08:00–19:00), for every part we sell. The team confirms the installation price and time for your part — message us on WhatsApp with the part and your car, or book an appointment. If you have it installed elsewhere, check the fit before installing — a free exchange for a wrong fit is valid 48 hours from receipt.',
      wa: 'Hello, how much is the installation and when can I come? Part: ____, car: ____.',
      waLabel: 'Ask the team on WhatsApp', term: 'Book an appointment'
    },
    de: {
      body: 'Ja — <b>den Einbau machen wir selbst</b>, im Laden in Ferizaj (Montag–Samstag 08:00–19:00), für jedes Teil, das wir verkaufen. Preis und Dauer des Einbaus für dein Teil bestätigt das Team — schreib uns auf WhatsApp mit Teil und Fahrzeug, oder vereinbare einen Termin. Wenn du es woanders einbauen lässt, prüfe die Passform vor dem Einbau — der kostenlose Umtausch bei falscher Passform gilt 48 Stunden ab Erhalt.',
      wa: 'Hallo, was kostet der Einbau und wann kann ich kommen? Teil: ____, Fahrzeug: ____.',
      waLabel: 'Team auf WhatsApp fragen', term: 'Termin vereinbaren'
    }
  };

  function s7Html(lang) {
    var x = T[lang] || T.en;
    return x.body + '<p class="bacinext">' + waLink(x.wa, x.waLabel) + ' · ' + termLink(x.term) + '</p>';
  }

  window.BaciServiceRules.push(function (t, lang) {
    try { return any(t, INSTALL) ? s7Html(lang) : null; } catch (e) { return null; }
  });
  window.BACI_SERVICE7_READY = true;
})();
